import { SearchReduxAction, Constants } from 'actions/search'
import { Search } from 'types/Search'

type State = Search

export default function search(state: State = {}, action: SearchReduxAction): State {
  switch (action.type) {
    case Constants.SET:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
